/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import analytics from "../analytics/analytics";
import traversal from "../dom/traversal";

const MAX_VISIBLE_BUY_OPTIONS = 3;

const componentName = "multiprice-buy-area";
const hiddenClassName = "hidden";
const buyButtonSelector = `.${componentName}__buy-button`;
const wrapperSelector = `.${componentName}__wrapper`;
const buyOptionSelector = `.${componentName}__card`;
const showMoreButtonSelector = `.${componentName}__show-more`;
const showLessButtonSelector = `.${componentName}__show-less`;
const multipriceContainerSelector = `.${componentName}__container`;

function toggle(el) {
    el.classList.toggle(hiddenClassName);
}

export default baustein.register("multiprice-buy-area", {
    setupEvents(add) {
        add("click", buyButtonSelector, this.sendAnalytics);
        add("click", showMoreButtonSelector, this.showMoreBuyOptions);
        add("click", showLessButtonSelector, this.showLessBuyOptions);
        this.firstTimeToggleBuyOptions = true;
    },

    showMoreBuyOptions() {
        const wrapper = this.el.querySelector(wrapperSelector);

        if (this.firstTimeToggleBuyOptions) {
            this.collapsedHeight = `${wrapper.scrollHeight}px`;
            wrapper.style.height = this.collapsedHeight;
            const buyOptions = this.el.querySelectorAll(buyOptionSelector);

            // https://git.lystit.com/lyst/lyst/pull/12772#discussion_r58867
            for (let index = MAX_VISIBLE_BUY_OPTIONS; index < buyOptions.length; index++) {
                const buyOption = buyOptions[index];
                toggle(buyOption);
            }

            this.expandedHeight = `${wrapper.scrollHeight}px`;
            this.firstTimeToggleBuyOptions = false;
        }

        wrapper.style.height = this.expandedHeight;

        this.toggleShowButton();
        analytics.event("Merged PDP", "Clicked Show More");
    },

    showLessBuyOptions() {
        const wrapper = this.el.querySelector(wrapperSelector);
        wrapper.style.height = this.collapsedHeight;

        this.toggleShowButton();
        analytics.event("Merged PDP", "Clicked Show Less");
    },

    toggleShowButton() {
        toggle(this.el.querySelector(showMoreButtonSelector));
        toggle(this.el.querySelector(showLessButtonSelector));
    },

    sendAnalytics(event) {
        const multipriceContainers = Array.from(
            this.el.querySelectorAll(multipriceContainerSelector)
        );
        const clickedContainer = traversal.closest(event.target, multipriceContainerSelector);
        // + 1 because we wanted the position, not index
        const position = multipriceContainers.indexOf(clickedContainer) + 1;
        analytics.event("Merged PDP", "Clicked Buy", position);
    }
});

